import EntryScreen from '@/screens/profile-screen/edit/EntryScreen'

export default function EntryScreenRoute() {
  return <EntryScreen />
}

